import { Permission } from 'core/api';
import { Result } from 'core/infrastructure';
import { Preconditions } from 'core/infrastructure-next';
import { Command } from 'pos/common';
import * as TakeOutOrderStore from './TakeOutOrderStore';

declare global {
	interface CommandType {
		acceptTakeOutOrder: (orderId: number) => Promise<Result>
	}
}

Command.register('acceptTakeOutOrder', Preconditions.and(Preconditions.ensure(Permission.SalesOrder_Accept), Preconditions.ensureIsNotLite), async (orderId: number): Promise<Result> => {
	await TakeOutOrderStore.accept(orderId);
	return Result.ok();
});
